
import React, { useState } from 'react';
import { useInterviewRequests } from '@/hooks/interview/useInterviewRequests';
import InterviewRequestList from './InterviewRequestList';
import RequestsHeader from './requests/RequestsHeader';
import RequestsLoadingState from './requests/RequestsLoadingState';
import RequestsErrorState from './requests/RequestsErrorState';
import RequestsEmptyState from './requests/RequestsEmptyState';
import ViewRequestDialog from './requests/ViewRequestDialog';
import { InterviewRequestResponse } from '@/services/interview/requests/types';

interface InterviewRequestsTabProps {
  onCreateNew: () => void;
}

const InterviewRequestsTab: React.FC<InterviewRequestsTabProps> = ({ onCreateNew }) => {
  const {
    interviewRequests,
    isLoading,
    error,
    isError,
    refetch,
    handleRefresh,
    handleDeleteSuccess
  } = useInterviewRequests();
  
  const [viewingRequest, setViewingRequest] = useState<InterviewRequestResponse | null>(null);
  const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);

  const handleViewRequest = (request: InterviewRequestResponse) => {
    setViewingRequest(request);
    setIsViewDialogOpen(true);
  };

  const handleCloseViewDialog = () => {
    setIsViewDialogOpen(false);
  };

  return (
    <div>
      <RequestsHeader 
        onRefresh={handleRefresh}
        onDeleteAll={handleRefresh}
        hasRequests={interviewRequests.length > 0}
      />
      
      {isLoading ? (
        <RequestsLoadingState />
      ) : isError ? (
        <RequestsErrorState error={error} onRetry={handleRefresh} />
      ) : !interviewRequests || interviewRequests.length === 0 ? (
        <RequestsEmptyState onCreateNew={onCreateNew} />
      ) : (
        <>
          <InterviewRequestList 
            interviewRequests={interviewRequests}
            onCreateNew={onCreateNew}
            onDeleteSuccess={handleDeleteSuccess}
            onViewRequest={handleViewRequest}
          />
          
          <ViewRequestDialog 
            request={viewingRequest}
            isOpen={isViewDialogOpen}
            onClose={handleCloseViewDialog}
          />
        </>
      )}
    </div>
  );
};

export default InterviewRequestsTab;
